<template>
  <div class="review-card">
    <span class="head">
      <img src="@/assets/logos/logo-black.svg" alt="Maisons Alysia">
      <strong class="agency" v-if="review.agency">{{ review.agency.name }} </strong>
    </span>
    <h3>{{ review.title }}</h3>
    <div class="infos">
      <small>
        <template v-if="review.rating === '5'">Excellent</template>
        <template v-else-if="review.rating === '4'">Très bon</template>
        <template v-else-if="review.rating === '3'">Satisfait</template>
        <template v-else-if="review.rating === '2'">Moyen</template>
        <template v-else-if="review.rating === '1'">Déçu</template>
      </small>
      <span class="rate">
        <template v-if="review.rating === '5'">★ ★ ★ ★ ★</template>
        <template v-else-if="review.rating === '4'">★ ★ ★ ★</template>
        <template v-else-if="review.rating === '3'">★ ★ ★</template>
        <template v-else-if="review.rating === '2'">★ ★</template>
        <template v-else-if="review.rating === '1'">★</template>
      </span>
    </div>
    <p>
      {{ review.description }}
    </p>
    <h5>{{ review.user.login }}</h5>
    <div class="date">
      Le {{ review.exp.date }}
      <slot v-if="review.agency">pour Maisons Alysia  {{ review.agency.name }}</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewCard',
  props: {
    review: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="sass">
.review-card
  position: relative
  display: flex
  flex-direction: column
  gap: 10px
  padding: 40px 40px 50px
  border: 1px solid #FAFAFA
  box-shadow: $drop-shadow
  border-radius: 20px
  background: white
  @media (max-width: 768px)
    padding: 40px 30px 100px
  h3
    font-size: 130%
  h5
    margin: 10px 0
  img
    margin-bottom: 10px
    max-width: 80px
  .head
    display: flex
    gap: 10px
    align-items: center
    @media (max-width: 768px)
      flex-direction: column
      align-items: flex-start
    strong
      padding-bottom: 1px
      color: $primary
      font-size: 0.88rem
  .infos
    position: absolute
    top: 48px
    right: 25px
    display: flex
    gap: 10px
    align-items: center
    @media (max-width: 768px)
      position: relative
      top: 0
      right: 0
      margin-bottom: 20px
    .rate
      color: $primary
      font-size: 120%
      text-shadow: 0 2px 4px rgba(0,0,50,0.05)
      background: linear-gradient(-90deg, $warning, lighten($warning, 30%))
      -webkit-background-clip: text
      -webkit-text-fill-color: transparent
    small
      font-weight: bold
      color: $black
  .date
    font-size: 0.7rem
    color: $secondary-light
    font-style: italic
  &:after
    position: absolute
    bottom: -10px
    right: 20px
    content: "”"
    font-size: 220px
    line-height: 40px
    font-family: "Times New Roman", serif
    color: lighten($primary, 40%)
</style>
